import R from 'ramda';
import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

const initialState = {
  bedroomCount: 0,
};

export default handleActions(
  {
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { bedroomCount = 0 } },
    ) => ({
      ...state,
      bedroomCount: R.is(Number, bedroomCount)
        ? bedroomCount
        : parseInt(bedroomCount, 10),
    }),
  },
  initialState,
);

export const getRoomsFilter = state => state;
